module.exports = __webpack_public_path__ + "media/images/athletes/542-ec123776c409456a57af4fae01780755.png";